const asyncActions = [
  'NOOP'
]

export default asyncActions
